import {
	Box,
	Button,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DragIndicator, MoreHoriz } from '@mui/icons-material';
import fp from 'lodash/fp';
import React from 'react';

import { useMenu } from 'hooks';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 80,
		paddingLeft: 20,
		paddingRight: 20
	},
	item: { verticalAlign: 'center' },
	text: { paddingTop: 20 },
	icon: { color: '#757575', marginLeft: 20, marginTop: 20 },
	button: { paddingTop: 20, paddingBottom: 20 }
}));

const EventListItem = ({
	event,
	isSelectable,
	handleShowAcademyEvent,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const classes = useStyles();

	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleDeleteClick(event, e)}>Delete</MenuItem>
			<MenuItem onClick={(e) => handleEditClick(event, e)}>Edit</MenuItem>
		</Menu>
	);

	return (
		<Grid container spacing={1} className={classes.root}>
			<Grid item md={1} xs={12} className={classes.item}>
				<DragIndicator className={classes.icon} />
			</Grid>
			<Grid item md={3} xs={12} className={classes.item}>
				<a
					onClick={(e) => {
						e.stopPropagation();
						handleShowAcademyEvent(event);
					}}
				>
					<Typography variant="body1" className={classes.text}>
						{event.name}
					</Typography>
				</a>
			</Grid>
			<Grid item md={2} xs={12} className={classes.item}>
				<a
					onClick={(e) => {
						e.stopPropagation();
						handleShowAcademyEvent(event);
					}}
				>
					<Typography variant="body1" className={classes.text}>
						{format(event.start_date, 'yyyy-m-d h:mm a')}
					</Typography>
				</a>
			</Grid>

			<Grid item md={2} xs={12} className={classes.item}>
				<a
					onClick={(e) => {
						e.stopPropagation();
						handleShowAcademyEvent(event);
					}}
				>
					<Typography variant="body1" className={classes.text}>
						{format(event.end_date, 'yyyy-m-d h:mm a')}
					</Typography>
				</a>
			</Grid>
			<Grid item md={2} xs={12} className={classes.item}>
				<a
					onClick={(e) => {
						e.stopPropagation();
						handleShowAcademyEvent(event);
					}}
				>
					<Typography variant="body1" className={classes.text}>
						{event.published ? 'Yes' : 'No'}
					</Typography>
				</a>
			</Grid>
			<Grid className={classes.item} item md={1} xs={12}>
				<IconButton onClick={(e) => handleToggleMenu(e)}>
					<MoreHoriz />
					{renderMenu()}
				</IconButton>
			</Grid>
		</Grid>
	);
};

export default EventListItem;
